module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control has-icon search-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "input is-medium",
    attrs: {
      "type": "text",
      "placeholder": "Procurar Utilizadores"
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b25a63d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserSearch.vue
// module id = 331
// module chunks = 1